//#region src/users/admin/adminUsersQueryKeys.ts
var e = {
	all: ["admin-users"],
	list: (e) => [
		"admin-users",
		"list",
		e ?? {}
	],
	detail: (e) => [
		"admin-users",
		"detail",
		e
	],
	workspaces: (e) => [
		"admin-users",
		"workspaces",
		e
	]
};
//#endregion
export { e as adminUsersQueryKeys };
